import clsx from 'clsx'
import { useMemo, type FC } from 'react'

import { Text } from '@wartek-id/text-v1'
import { Shimmer } from '@wartek-id/shimmer'

import CompetencyStepper from './CompetencyStepper'
import TooltipRelative from 'app/PemetaanKompetensiPage/components/ProfileRevamp/TooltipRelative'
import {
  CompetencyProficiency,
  type CompetencyCardProps,
} from 'app/PemetaanKompetensiPage/components/ProfileRevamp/CompetencyCard'
import styles from './CompetencyCardAnimated.module.css'
import { assetUrl } from 'utils/url'

import type { TProficiency } from 'types/competency-profile'

const CompetencyCardAnimated: FC<CompetencyCardProps> = ({
  name,
  className,
  isLoading,
  minimumLevel,
  level,
  onClick,
}) => {
  const proficiency: TProficiency = useMemo(() => {
    if (level == 0) return 'nodata'
    if (level == minimumLevel) return 'equal'
    return level > minimumLevel ? 'higher' : 'under'
  }, [level, minimumLevel])

  return (
    <button
      onClick={onClick}
      className={clsx(
        styles.animatedCompetencyCard,
        'rounded-lg block w-full border-subdued border p-4 space-y-4 bg-white',
        className
      )}
    >
      {isLoading ? (
        <Shimmer height={24} width={240} className="max-w-full" />
      ) : (
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-center gap-3.5">
            <div>
              <div className="flex items-center gap-3.5">
                <img
                  src={assetUrl(
                    '/images/refleksi-kompetensi/pedagogik-animated.gif'
                  )}
                  alt=""
                  width={48}
                  height={48}
                />
                <Text variant="heading-md" className="capitalize">
                  {name}
                </Text>
              </div>
              <TooltipRelative />
            </div>
          </div>
        </div>
      )}
      <div className="p-3 rounded-lg flex flex-col gap-4 bg-gray-0">
        <CompetencyStepper step={level} />
        <div className="flex flex-row gap-2 items-center">
          {CompetencyProficiency[proficiency].icon}
          <Text variant="body-sm">
            {CompetencyProficiency[proficiency].label}
          </Text>
        </div>
      </div>
    </button>
  )
}
export default CompetencyCardAnimated
